import {PRODUCT_OPTION_BINDING_CONTEXT_TYPE_ID} from './identifiers';

import type {
  BindingContextTypeDef,
  BindablePropertiesDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';

export const productOptionType: BindingContextTypeDef = {
  entity: 'Entity',
  id: PRODUCT_OPTION_BINDING_CONTEXT_TYPE_ID,
  label: 'Product Options',
  pluralLabel: 'Product Options',
  singularLabel: 'Product Option',
  iconName: 'product',
};

export function productOptionBindableProperties<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindablePropertiesDef<EntityTRef, ListTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'Entity',
      id: PRODUCT_OPTION_BINDING_CONTEXT_TYPE_ID,
    }),
    bindableProperties: [
      {
        id: 'product-option-name',
        type: 'PlainText',
        label: 'Name',
        path: [{id: '', slug: 'name', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
      {
        id: 'product-option-value',
        type: 'PlainText',
        label: 'Value',
        path: [{id: '', slug: 'value', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
    ],
  };
}
